/* Dabi Deri — tema metni çevirmeni (Türkçe dışı dillerde).

   Neden: Bölüm ayarlarına yazılan Türkçe metinler (alt bilgi, bülten, blog etiketleri,
   koleksiyon yazıları…) Shopify'da yalnızca Translate & Adapt ile çevrilir ve o çeviri
   temaya özeldir. Etiket ve ürün türü gibi bazı şeyler ise hiç çevrilemez. Bu betik,
   sözlükte (assets/dabi-dict-<dil>.js) karşılığı olan Türkçe metinleri sayfa çizilirken
   değiştirir; sonradan eklenen içerik (filtre, çekmece, sepet) de izlenir.

   - Translate & Adapt ile çevrilmiş metin zaten İngilizce gelir; sözlükle eşleşmez, dokunulmaz.
   - "{n} ürün" gibi yer tutuculu kalıplar desen olarak eşleşir; yakalanan parça da çevrilir.
   - <script>, <style>, <textarea>, düzenlenebilir alanlar ve [data-no-translate] atlanır.
   - Görünen yazının yanında placeholder, title, aria-label, alt ve data-label* gibi
     özellikler de çevrilir (betikler bunları sonradan okur). */
(() => {
  const D = window.DabiDict;
  if (!D) return;
  const norm = (s) => s.replace(/\s+/g, ' ').trim();
  const map = new Map(Object.entries(D));
  const pats = [];
  map.forEach((v, k) => {
    if (!/\{[a-z_]+\}/.test(k)) return;
    const names = [];
    const src = k.replace(/[.*+?^$()|[\]\\]/g, '\\$&').replace(/\{([a-z_]+)\}/g, (m, n) => { names.push(n); return '(.+?)'; });
    pats.push({ re: new RegExp(`^${src}$`), names, v });
  });

  const tr = (raw) => {
    const n0 = norm(raw);
    if (!n0 || n0.length < 2) return null;
    // "Ad soyad *" ya da "Yapacağınız:" gibi sonekler: kökü çevir, soneki geri ekle
    const suf = n0.match(/\s*[:*]+$/);
    if (suf && n0.length > suf[0].length + 1) {
      const base = tr(n0.slice(0, -suf[0].length));
      if (base !== null) return base + suf[0];
    }
    // tırnak içindeki alıntı: içini çevir, tırnakları koru
    const q = n0.match(/^([“"‘'«(]+)(.+?)([”"’'»)]+)$/);
    if (q) {
      const inner = tr(q[2]);
      if (inner !== null) return q[1] + inner + q[3];
    }
    const n = n0;
    const hit = map.get(n);
    if (hit !== undefined) return hit;
    for (let i = 0; i < pats.length; i += 1) {
      const m = n.match(pats[i].re);
      if (m) {
        let out = pats[i].v;
        pats[i].names.forEach((nm, j) => { const val = m[j + 1]; out = out.replace(`{${nm}}`, map.get(norm(val)) || val); });
        return out;
      }
    }
    return null;
  };

  const ATTRS = ['placeholder', 'title', 'aria-label', 'alt', 'data-label-show', 'data-label-hide', 'data-label-add', 'data-label-added',
    'data-label-error', 'data-add', 'data-added', 'data-error', 'data-fav-on', 'data-fav-off', 'data-empty', 'data-less', 'data-more',
    'data-label', 'data-label-choose', 'data-copied', 'data-text', 'data-text-left', 'data-text-done'];
  const SKIP = new Set(['SCRIPT', 'STYLE', 'TEXTAREA', 'NOSCRIPT', 'CODE', 'PRE', 'SVG']);
  const skipEl = (el) => !el || SKIP.has(el.nodeName.toUpperCase()) || el.isContentEditable || (el.closest && el.closest('[data-no-translate], script, style, textarea'));

  const doText = (t) => {
    const v = t.nodeValue;
    if (!v || !/[A-Za-zÇĞİÖŞÜçğıöşü]/.test(v)) return;
    const out = tr(v);
    if (out === null) return;
    const lead = v.match(/^\s*/)[0];
    const trail = v.match(/\s*$/)[0];
    const next = lead + out + trail;
    if (next !== v) t.nodeValue = next;
  };
  const doAttrs = (el) => {
    for (let i = 0; i < ATTRS.length; i += 1) {
      const a = ATTRS[i];
      if (!el.hasAttribute(a)) continue;
      const v = el.getAttribute(a);
      const out = v && tr(v);
      if (out && out !== v) el.setAttribute(a, out);
    }
    if (el.nodeName === 'INPUT' && (el.type === 'submit' || el.type === 'button') && el.value) {
      const out = tr(el.value);
      if (out) el.value = out;
    }
  };
  const walk = (root) => {
    if (root.nodeType === 3) { if (!skipEl(root.parentElement)) doText(root); return; }
    if (root.nodeType !== 1 || skipEl(root)) return;
    doAttrs(root);
    const w = document.createTreeWalker(root, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT, {
      acceptNode: (n) => (n.nodeType === 1 && SKIP.has(n.nodeName.toUpperCase()) ? NodeFilter.FILTER_REJECT : NodeFilter.FILTER_ACCEPT),
    });
    let n = w.nextNode();
    while (n) {
      if (n.nodeType === 3) { if (!skipEl(n.parentElement)) doText(n); } else if (!n.isContentEditable) doAttrs(n);
      n = w.nextNode();
    }
  };

  const mo = new MutationObserver((list) => {
    for (let i = 0; i < list.length; i += 1) {
      const m = list[i];
      if (m.type === 'childList') m.addedNodes.forEach(walk);
      else if (m.type === 'characterData') { if (!skipEl(m.target.parentElement)) doText(m.target); }
      else if (m.type === 'attributes') doAttrs(m.target);
    }
  });
  mo.observe(document.documentElement, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ATTRS });
  if (document.body) walk(document.body);
  document.addEventListener('DOMContentLoaded', () => walk(document.body));
  window.DabiTranslate = { tr, walk };
})();
